// Color constants
const SUCCESS_TEXT = "#2CA24B"
const SUCCESS_BG = "#F0FFF4"
const INFO_TEXT = "#0065D0"
const INFO_BG = "#E3F5FB"
const ALERT_TEXT = "#D3180C"
const ALERT_BG = "#FFE5E5"
const WARNING_TEXT = "#CB6E00"
const WARNING_BG = "#FFEFD7"
const DEFAULT_TEXT = "#404446"
const DEFAULT_BG = "#E9EEF2"

export const STATUS_COLORS = {
  // Success states
  complete: SUCCESS_TEXT,
  qualified: SUCCESS_TEXT,
  approved: SUCCESS_TEXT,
  passed: SUCCESS_TEXT,

  // Info states (action available / in progress)
  open: INFO_TEXT,
  deferred: INFO_TEXT,
  in_progress: INFO_TEXT,
  pending: INFO_TEXT,
  registered: INFO_TEXT,
  attending: INFO_TEXT,
  submitted: INFO_TEXT,

  // Alert states (requires attention)
  in_review: ALERT_TEXT,
  returned: ALERT_TEXT,
  failed: ALERT_TEXT,
  expired: ALERT_TEXT,

  // Warning states
  locked: WARNING_TEXT,
  denied: WARNING_TEXT,

  // Default
  default: DEFAULT_TEXT,
}

export const STATUS_BACKGROUND_COLORS = {
  // Success states
  complete: SUCCESS_BG,
  qualified: SUCCESS_BG,
  approved: SUCCESS_BG,
  passed: SUCCESS_BG,

  // Info states (action available / in progress)
  open: INFO_BG,
  deferred: INFO_BG,
  in_progress: INFO_BG,
  pending: INFO_BG,
  registered: INFO_BG,
  attending: INFO_BG,
  submitted: INFO_BG,

  // Alert states (requires attention)
  in_review: ALERT_BG,
  returned: ALERT_BG,
  failed: ALERT_BG,
  expired: ALERT_BG,

  // Warning states
  locked: WARNING_BG,
  denied: WARNING_BG,

  // Default
  default: DEFAULT_BG,
}
